import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: {},
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit, rootState}, {page, filterData} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        state.filterData = filterData;

        let params = {
            page: page.current,
            page_limit: page.pageSize
        };

        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['company_customer'], {
            params: params
        })

        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    //  show record
    async show({commit, dispatch, rootState}, {id}) {
        commit('setLoading', true)
        commit('updateSaveData', {})

        const res = await this._vm.axios.get( this._vm.endpoints['company_customer'] + '/' + id );
        if (res.status) {
            const {data} = res.data
            commit('updateSaveData', data)
        } else {
            this._vm.$message.error(res.message)
        }

        commit('setLoading', false)
    },

    //  show record
    async add({commit, dispatch, rootState}, {formData}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['company_customer'],
                formData
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    // update record
    async update({commit, dispatch, rootState}, {id, formData}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.put(
                this._vm.endpoints['company_customer'] + '/' + id,
                formData
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    //  delete record
    async delete({commit, dispatch, rootState}, {id}) {
        let successDeleted = [];
        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['company_customer'] + '/' + id[i]);
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }

            dispatch('refresh')

            return successDeleted;
        }
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    }
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateSaveData(state, data) {
        state.save.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
